import React, { useState, useRef, useEffect, Image, Button, useRouter, DragDropContext, Droppable, Draggable} from "@/imports-files/pages/clients/jobs/assessment-dropzone";
import PageStyle from "@/styles/components/dropzone/_index.module.scss";
import Deviceicon from 'public/icons/device.svg';
import { closeDropDown, onAddCandidateRemoveFile, onFileChange, onCancel, onRemoveFile } from '@/imports-files/pages/career/view-job';
import {ButtonStyle} from '@/imports-files/common/common'

export default function AssessmentDropZone(props){

  const { formik } =  props
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const onClick = () => setIsActive(!isActive);
  const router = useRouter();
  const dropAction = props.dropAction

  useEffect(() => {
    let hash = { file_type: '', file: '', file_name: '' };
  }, [])

  useEffect(() => {
    const pageClickEvent = (e) => {
      // If the active element exists and is clicked outside of
      if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
        setIsActive(!isActive);
      }
    };

    // If the item is active (ie open) then listen for clicks
    if (isActive) {
      window.addEventListener('click', pageClickEvent);
    }

    return () => {
      window.removeEventListener('click', pageClickEvent);
    }

  }, [isActive]);

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  function documentList(drop_type, formik) {
    if(drop_type == 'contract'){
      return formik.values.contract.documents
    }
    else if(drop_type == 'template')
    {
      return formik.values.signature_template.documents
    }
  }

  return (
    <>
      <div className={PageStyle.DropContainer}>
        <div className={`${PageStyle.DropContainer__Inner} DropContainerInner`}
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          name={props.name}
          onDrop={(event) => {
            event.preventDefault();
            if (props.isDisabled)
              return false;
            else
              dropAction.uploadFile(props.formik, event.dataTransfer.files, event)
          }}
        >
          <div className={PageStyle.DropContainer__Message}>
            <div className={PageStyle.DropContainer__UploadIcon}></div>
            Drag & drop your file

            <div className={` BrowseFile ${PageStyle.Browse}`}>
              <Button buttonstyle={ButtonStyle.primarybtn} onClick={onClick} disabled={props.isDisabled}>
                Browse to Upload
              </Button>

              <nav ref={dropdownRef} className={`dropboxmenu ${isActive ? 'active' : 'inactive'}`}>
                <ul>
                  <li onClick={() => closeDropDown(setIsActive)}>
                    <label htmlFor={props.id}>
                      <Deviceicon /> from Device
                    </label>
                    <input type="file"
                      multiple={props.multiple}
                      onChange={(event) => { dropAction.uploadFile(props.formik, event.target.files, event)}}
                      name={props.name}
                      accept={props.accept}
                      id={props.id}
                    />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>


        {(formik.values.filename || formik.values.job_test_detail_attributes?.assessment?.filename)  && <div className={`${PageStyle.FileDisplayContainer} FileDisplayContainerW100`}>
          <div className={`${PageStyle.FileDisplayContainer__Status} FileDisplayWidth`}>
            <span className={`${PageStyle.FileDisplayContainer__Name} FileDisplayName`}>
            {formik.values.filename || formik.values.job_test_detail_attributes?.assessment?.filename}
            </span>
            <div className={`${PageStyle.FileDisplayContainer__Close} FileDisplayClose`}>
              <Image src="/icons/close.png" height={13} width={13} alt="" onClick={() => dropAction.onRemoveFile(formik, props.name)} />
            </div>
          </div>
        </div>}

      </div>
    </>
  );
};